/* Tidies the HulkApps option labels into card rows: pulls the trailing
   "(+$14.0)" out of the label text, normalises it to two decimals, and marks
   $0 options as "Included" rather than a price.

   Only touches text nodes - the checkbox and the app's own tick element are
   left exactly as they are, so HulkApps' handlers keep working. If this
   script never runs, the labels still read fine, just unformatted. */
(function () {
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  var PRICE = /\(\s*\+?\s*\$\s*([0-9]+(?:\.[0-9]+)?)\s*\)\s*$/;

  function money(n) {
    return '$' + n.toFixed(2);
  }

  function tidy(label) {
    if (label.dataset.rgppDone) return;

    /* the label text lives in direct text nodes, not an element */
    var nodes = [];
    for (var i = 0; i < label.childNodes.length; i++) {
      if (label.childNodes[i].nodeType === 3 && label.childNodes[i].textContent.trim()) {
        nodes.push(label.childNodes[i]);
      }
    }
    if (!nodes.length) return;

    var raw = nodes.map(function (n) { return n.textContent; }).join(' ').replace(/\s+/g, ' ').trim();
    var m = raw.match(PRICE);
    var name = (m ? raw.slice(0, m.index) : raw).trim().replace(/[-–,\s]+$/, '');
    var amount = m ? parseFloat(m[1]) : null;

    nodes.forEach(function (n) { n.textContent = ''; });

    var nameEl = document.createElement('span');
    nameEl.className = 'rgpp-opt-label';
    nameEl.textContent = name;
    label.appendChild(nameEl);

    if (amount !== null) {
      var priceEl = document.createElement('span');
      if (amount === 0) {
        priceEl.className = 'rgpp-opt-price is-free';
        priceEl.textContent = 'Included';
      } else {
        priceEl.className = 'rgpp-opt-price';
        priceEl.textContent = '+ ' + money(amount);
      }
      label.appendChild(priceEl);
    }

    label.dataset.rgppDone = '1';
  }

  /* :has(input:checked) does not reliably re-evaluate when the app toggles a
     box, so the selected state is mirrored onto a class we control. */
  function sync(label) {
    var input = label.querySelector('input.hulk_po_checkbox');
    if (input) label.classList.toggle('rgpp-opt-on', input.checked);
  }

  function syncAll() {
    document.querySelectorAll('label.hulkapps_check_option').forEach(sync);
  }

  function run() {
    document.querySelectorAll('label.hulkapps_check_option').forEach(function (l) {
      tidy(l);
      sync(l);
    });
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('hulk_po_checkbox')) {
      var label = e.target.closest('label.hulkapps_check_option');
      if (label) sync(label);
    }
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('label.hulkapps_check_option')) {
      setTimeout(syncAll, 0);
    }
  }, true);

  run();
  /* the app injects its options after page load, so watch for them */
  var mo = new MutationObserver(run);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); run(); }, 12000);
})();
